import * as React from 'react';
import { cn } from '@/lib/utils';

const ClassroomMain = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-classroom-main', 'flex w-full flex-col gap-y-6 lg:max-w-[70%]', className)}
    {...props}
  />
));
ClassroomMain.displayName = 'ClassroomMain';

const Classroom = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-classroom',
      'relative flex flex-wrap items-start justify-between gap-y-4',
      // Sidebar
      '[&_.c-classroom-sidebar]:lg:fixed',
      '[&_.c-classroom-sidebar]:lg:top-[105px]',
      '[&_.c-classroom-sidebar]:lg:right-[44px]',
      '[&_.c-classroom-sidebar]:lg:w-[20%]',
      '[&_.c-classroom-sidebar]:lg:h-[calc(100vh_-_105px)]',
      '[&_.c-classroom-sidebar]:lg:flex [&_.c-classroom-sidebar]:lg:flex-col',

      className
    )}
    {...props}
  >
    {children}
  </div>
));
Classroom.displayName = 'Classroom';

export { ClassroomMain, Classroom };
